import React, { useState } from "react";

function ServerStatus() {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
        backgroundColor: "#15202e",
      }}
    >
      {hasError ? (
        <div style={{ color: "white", fontSize: "24px" }}>
          Under Maintenance
        </div>
      ) : (
        <iframe
          src="https://checkserver.azurewebsites.net/"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Server Status"
          onError={handleError}
        />
      )}
    </div>
  );
}

export default ServerStatus;
